/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ population: NonNullable<unknown> }} Coach_Studied_InInputs */

const en_us2_coach_studied_in = /** @type {(inputs: Coach_Studied_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Studied in: ${i?.population}`)
};

const pt_br2_coach_studied_in = /** @type {(inputs: Coach_Studied_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estudado em: ${i?.population}`)
};

const es_419_coach_studied_in = /** @type {(inputs: Coach_Studied_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estudiado en: ${i?.population}`)
};

const pt_pt2_coach_studied_in = /** @type {(inputs: Coach_Studied_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estudado em: ${i?.population}`)
};

const fr_fr2_coach_studied_in = /** @type {(inputs: Coach_Studied_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Étudié chez : ${i?.population}`)
};

const de_de2_coach_studied_in = /** @type {(inputs: Coach_Studied_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untersucht an: ${i?.population}`)
};

const it_it2_coach_studied_in = /** @type {(inputs: Coach_Studied_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Studiato su: ${i?.population}`)
};

/**
* | output |
* | --- |
* | "Studied in: {population}" |
*
* @param {Coach_Studied_InInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_studied_in = /** @type {((inputs: Coach_Studied_InInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Studied_InInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_studied_in(inputs)
	if (locale === "es-419") return es_419_coach_studied_in(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_studied_in(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_studied_in(inputs)
	if (locale === "de-DE") return de_de2_coach_studied_in(inputs)
	if (locale === "it-IT") return it_it2_coach_studied_in(inputs)
	return en_us2_coach_studied_in(inputs)
});
export { coach_studied_in as "coach.studied_in" }